import React, { useState, useEffect } from "react";
import { Form, Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { Link,NavLink, useHistory } from 'react-router-dom';
import Button from "web/components/Button";
import TextInput from "web/components/form-elements/TextInput";
import CheckboxInput from "web/components/form-elements/CheckboxInput";
import { INITIAL_VALUES, VALIDATION_SCHEMA, } from "web/components/utils/acknowledgeModalUtils";
import { acknowledgeApi, getTermsAndConditionsApi, acknowledgeLatestVersionApi } from "redux/actions/auth";
import AlertModal from "web/components/AlertModal";
import CloseIcon from "web/assets/images/CloseIcon.png";
import { Modal, ModalBody, ModalFooter } from "reactstrap";
import "./alert.scss";
import styled from "styled-components";
import Spinner from "../../components/Spinner";

export default ({ isOpen, toggle, title, content, link, acknowledgeCallBack, }) => {
  const dispatch = useDispatch();
  let history = useHistory();
  const [pageContent, setPageContent] = useState()
  const [isModelOpen, setIsModelOpen] = useState(false);
  const [alertType, setAlertType] = useState();
  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [modalLink, setModalLink] = useState("/");
  const toggleModal = () => setModal(!modal);

  const redirectLink = (link) => {
    setIsModelOpen(!isModelOpen);
    toggle(!isOpen);
  };
  const [acknowledgeState, setAcknowledgeState] = useState(false);
  const token = localStorage.getItem("token");
  const isTnCAcknowledged = localStorage.getItem("isTnCAcknowledged");
  localStorage.removeItem("isTnCAcknowledged");

  useEffect(() => {
    if (!pageContent) fetchPageContent()
  }, [])

  const fetchPageContent = async () => {
    let accountType = localStorage.getItem('accountType')
    let userRole = ''
    if (accountType === 'Guest') {
      userRole = 'GUEST'
    } else {
      userRole = 'MEMBER'
    }
    let response = await dispatch(getTermsAndConditionsApi({ token, userRole }))
    if (response.content) {
      setIsModelOpen(true);
      setPageContent(response)
    }
  }

  const acknowledgeModalApi = async (props) => {
    const { values, resetForm } = props;
    let email = localStorage.getItem("email") ? localStorage.getItem("email") : ''

    let data = {
      id: pageContent.id,
      tcversion: pageContent.tcversion
    }
    let response
    if (isTnCAcknowledged === 'true') {
      await dispatch(acknowledgeApi(props.values.acknowledgeName, token))
      response = await dispatch(acknowledgeLatestVersionApi(email, props.values.acknowledgeName, data, token));
    } else {
      response = await dispatch(acknowledgeApi(props.values.acknowledgeName, token));
      dispatch(acknowledgeLatestVersionApi(email, props.values.acknowledgeName, data, token))
    }
    if (response.status === "SUCCESS") {
      setAlertType("acknowledge");
      setModalContent('Acknowledged successfully.');
      setModalLink("");
      toggleModal();
    } else {
      if (response.statusCode === 401) {
        history.push('./sign-in')
        window.location.reload(false);
      } else {
        setAlertType();
        setModalContent(response?.data?.error?.message || response?.data?.message || response?.message || 'Something went wrong, please try again in some time.');
        setModalLink("");
        toggleModal();
      }
    }
  };

  const createMarkupForPageContent = () => {
    if (pageContent) return { __html: pageContent.content }
  }

  return (
    <>
      <div className="alert-modal">
        {pageContent &&
          <Modal
            isOpen={isOpen}
            toggle={toggle}
            backdrop={"static"}
            centered={true}
            className="acknowledgeModal"
          >
            <div>
              <div className="header">
                <Button
                  handleClick={() => {
                    redirectLink(link);
                  }}
                >
                  <img src={CloseIcon} className="closeIcon" alt="close-icon" />
                </Button>
                <h3>System Operational Terms & Conditions</h3>
              </div>
              <ModalBody>
                <div className="modal-content">
                  <Formik
                    initialValues={INITIAL_VALUES}
                    validationSchema={VALIDATION_SCHEMA()}
                    onSubmit={(values) => { }}
                  >
                    {(props) => {
                      const { isValid, dirty, values, errors, touched } = props;
                      return (
                        <>
                          <Form>
                            <p>
                              Please read, acknowledge and agree to the following
                              operational terms & conditions.
                            </p>

                            <TermText>
                              <div dangerouslySetInnerHTML={createMarkupForPageContent()} />
                            </TermText>
                            <TextInput
                              name="acknowledgeName"
                              inputType="textAndNumber"
                              placeholder={"Name"}
                            />
                            <CheckboxInput
                              name="acknowledgeCheckBox"
                              label={
                                "I acknowledge and agree to the above outlined operational terms and conditions."
                              }
                              handleSelect={(name, label, e) => {
                                setAcknowledgeState(e);
                              }}
                            />
                            {acknowledgeState && (
                              <Button
                                type="app-green-button submitBtn"
                                disabled={!(isValid && dirty)}
                                handleClick={() => {
                                  acknowledgeModalApi(props);
                                }}
                              >
                                Send
                              </Button>
                            )}
                          </Form>
                        </>
                      );
                    }}
                  </Formik>
                </div>
              </ModalBody>
              <ModalFooter className="modal-footer"></ModalFooter>
            </div>
          </Modal>
        }
      </div>
      <AlertModal
        isOpen={modal}
        toggle={toggleModal}
        title={title}
        alertType={alertType}
        callBackAlert={(val) => {
          if (val === "acknowledge") {
            acknowledgeCallBack();
          }
        }}
        content={modalContent}
        link={modalLink}
      />
    </>
  );
};

const TermText = styled.div`
  overflow: auto;
  height: calc(100vh - 426px);
  text-align: left;
  border: 2px solid #ccc;
  margin: 25px 0;
  padding: 10px;
  p {
    color: #191819 !important;
      font-size: 16px !important;
      line-height: normal !important;
        text-align: justify !important;
        margin-bottom: 10px !important;
  }
  .checkbox-field {
    margin-top: 50px;
  }
`;